import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { deepMix } from '@antv/util';
import { group, max } from 'd3-array';
import { columnOf, constant, maybeColumnOf, visualColumn } from './utils/helper';
/**
 * Group marks by channels into groups and stacking their enterDelay
 * to make marks show up groups by groups.
 * It will update enterDelay channel for each mark by its enterDuration and group.
 * @todo Support orderBy.
 * @todo Sort among groups(e.g. reverse).
 * @todo Stack enter in groups rather than between groups?
 * @todo Auto inter this statistic for scaleInY animation in stacked interval?
 * @todo All the groups shared the enterDuration?
 */
export var StackEnter = function StackEnter(options) {
  var _options$groupBy = options.groupBy,
    groupBy = _options$groupBy === void 0 ? ['x'] : _options$groupBy,
    _options$reducer = options.reducer,
    reducer = _options$reducer === void 0 ? function (I, V) {
      return V[I[0]];
    } : _options$reducer,
    _options$orderBy = options.orderBy,
    orderBy = _options$orderBy === void 0 ? null : _options$orderBy,
    _options$reverse = options.reverse,
    reverse = _options$reverse === void 0 ? false : _options$reverse,
    duration = options.duration;
  return function (I, mark) {
    var encode = mark.encode; // Extract group information by each specified channel,
    // and skip if all values of channels are empty.
    var by = Array.isArray(groupBy) ? groupBy : [groupBy];
    var groupEntries = by.map(function (k) {
      return [k, columnOf(encode, k)[0]];
    });
    if (groupEntries.length === 0) return [I, mark];
    // Nest group index and flatten them in right order among timeline.
    // [[1, 2, 3, 4, 5, 6]] ->
    // [[1, 2, 3], [4, 5, 6]] ->
    // [[1], [2], [3], [4], [5], [6]]
    var groups = [I];
    var _iterator = _createForOfIteratorHelper(groupEntries),
      _step;
    try {
      var _loop = function _loop() {
        var _step$value = _slicedToArray(_step.value, 2),
          V = _step$value[1];
        var newGroups = [];
        for (var _i = 0, _groups = groups; _i < _groups.length; _i++) {
          var _I2 = _groups[_i];
          var G = Array.from(group(_I2, function (i) {
            return V[i];
          }).values());
          // @todo sort by x.
          newGroups.push.apply(newGroups, G);
        }
        groups = newGroups;
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
      // const {color} = encode;
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (orderBy) {
      var _columnOf = columnOf(encode, orderBy),
        _columnOf2 = _slicedToArray(_columnOf, 1),
        V = _columnOf2[0];
      if (V) groups.sort(function (I, J) {
        return reducer(I, V) - reducer(J, V);
      });
      if (reverse) groups.reverse();
    }
    // Stack delay for each group.
    var t = (duration || 3000) / groups.length;
    var _ref = duration ? [constant(I, t)] // If specified duration, generate enter duration for each.
      : maybeColumnOf(encode, 'enterDuration', constant(I, t)),
      _ref2 = _slicedToArray(_ref, 1),
      ED = _ref2[0];
    var _maybeColumnOf = maybeColumnOf(encode, 'enterDelay', constant(I, 0)),
      _maybeColumnOf2 = _slicedToArray(_maybeColumnOf, 1),
      EDL = _maybeColumnOf2[0];
    var newEnterDelay = new Array(I.length);
    for (var i = 0, pd = 0; i < groups.length; i++) {
      var _I = groups[i];
      var maxDuration = max(_I, function (i) {
        return +ED[i];
      });
      var _iterator2 = _createForOfIteratorHelper(_I),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var j = _step2.value;
          newEnterDelay[j] = +EDL[j] + pd;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      pd += maxDuration;
    }
    return [I, deepMix({}, mark, {
      encode: {
        enterDuration: visualColumn(ED),
        enterDelay: visualColumn(newEnterDelay)
      }
    })];
  };
};
StackEnter.props = {};